"use client";

import { Button } from "@/components/ui/button";
import { BurgerIcon, RevvaIcon } from "../../../../public/icons";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useEffect, useState } from "react";

const Navbar: React.FC = () => {
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const checkScreenSize = () => {
      if (window.innerWidth >= 640) {
        setIsOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  const handleClick = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <section>
        {pathname.startsWith("/sign-up") ? (
          <div className="flex justify-center items-center bg-[#FCFAF4] lg:py-[1.625rem] sm:py-[1.325rem] md:py-[1.475rem] py-[1.125rem]">
            <Link href="/">
              <RevvaIcon />
            </Link>
          </div>
        ) : (
          <div className="flex justify-between items-center bg-[#FCFAF4] lg:py-[1.625rem] sm:py-[1.325rem] md:py-[1.475rem] py-[1.125rem] px-4 md:px-[6.25rem]">
            <Link href="/">
              <RevvaIcon />
            </Link>

            <div className="hidden sm:flex gap-8">
              <Button
                size="xl"
                className="font-semibold text-base text-[#855C00] py-3 px-8"
                variant="secondary"
              >
                <Link href="https://app.revvapay.com">Sign In</Link>
              </Button>
              <Button
                size="xl"
                className="font-semibold text-base py-3 px-8"
                asChild
              >
                <Link href="/sign-up">Get Started</Link>
              </Button>
            </div>

            <div className="sm:hidden cursor-pointer" onClick={handleClick}>
              <BurgerIcon />
            </div>
          </div>
        )}
      </section>
      <div className="sm:hidden">
        <Dialog open={isOpen} onOpenChange={handleClick}>
          <DialogContent className="left-0 bg-[#FCFAF4] pt-4 flex flex-col h-screen max-w-[375px] translate-x-[-0%] overflow-y-scroll">
            <div className="px-4" onClick={handleClick}>
              <Link href="/">
                <RevvaIcon />
              </Link>
            </div>
            <div className="pb-10 pt-10 border-b border-[#E5E7EB]">
              <div className="px-4 flex flex-col">
                <Link
                  href="/"
                  className={`text-lg pb-8 ${
                    pathname === "/"
                      ? "font-extrabold text-[#044752]"
                      : "font-medium text-[#022329]"
                  } `}
                  onClick={handleClick}
                >
                  Home
                </Link>
                <Link
                  href="/terms-and-conditions"
                  className={`text-lg pb-8 ${
                    pathname === "/terms-and-conditions"
                      ? "font-extrabold text-[#044752]"
                      : "font-medium text-[#022329]"
                  } `}
                  onClick={handleClick}
                >
                  Terms & Condition
                </Link>
                <Link
                  href="/privacy-policy"
                  className={`text-lg ${
                    pathname === "/privacy-policy"
                      ? "font-extrabold text-[#044752]"
                      : "font-medium text-[#022329]"
                  } `}
                  onClick={handleClick}
                >
                  Privacy Policy
                </Link>
              </div>
            </div>
            <div className="pb-10 pt-10">
              <div className="px-4">
                <h6 className="font-semibold text-base text-[#044752] mb-8">
                  Terms & Condition
                </h6>
                <h6 className="font-medium text-sm text-[#022329] mb-4">
                  Email: support@revvapay.com
                </h6>
                <h6 className="font-medium text-sm text-[#022329]">
                  Phone: +234 8123456790
                </h6>
              </div>
            </div>
            <div className="py-14 border-t border-[#E5E7EB]">
              <div className="flex flex-col gap-4 px-4">
                <Button
                  onClick={handleClick}
                  size={"xl"}
                  asChild
                  className="w-full font-semibold text-base text-[#fff] py-4 px-14 rounded-lg border-0"
                >
                  <Link href="/sign-up">Get Started</Link>
                </Button>
                <Button
                  size={"xl"}
                  className="w-full font-bold text-base text-[#fff] py-4 px-14 rounded-lg"
                  variant={"warning"}
                >
                  Request a Demo
                </Button>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </>
  );
};

export default Navbar;
